// extracted by mini-css-extract-plugin
export default {"root":"juqxlK","large":"lXt5dO","mobile":"oPxDbe","thumbnail":"cOXfvl","media":"GJykEm","layout":"q9uiAI"};